import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


const QuoteBlock = (props) => {
  const {
    quote,
    author,
    title,
    sx,
  } = props;

  return (
    <Box
      id="quote_block"
      sx={{
        width: '100%',
        paddingTop: { md: '40px', lg: '40px' },
        paddingBottom: { xs: '20px', sm: '30px', lg: '40px' },
        paddingLeft: { md: '20px', lg: '20px' },
        paddingRight: { md: '40px', lg: '20px' },
        height: { xs: '340px', sm: '420px', md: '500px', lg: '100%' },
        // minHeight: { xs: '450px', sm: '560px', md: '500px', lg: '550px', xl: '450px' },
        backgroundColor: '#359F48',
        ...sx
      }}
    >
      <Stack 
        direction="row" 
        sx={{
          marginLeft: { xs: '10px', sm: '20px', md: '30px' },
        }}
      >
        <Typography
          sx={{
            fontFamily: 'CooperBTMedium',
            color: '#ffffff',
            // marginTop: { xs: '40px', sm: '57px', md: '36px', lg: '50px' },
            marginBottom: { xs: '10px', sm: '15px', lg: '20px' },
            fontSize: { xs: '26px', sm: '35px', md: '35px', lg: '52px' },
            lineHeight: { xs: '30px', sm: '42px', md: '42px', lg: '62px' },
            padding: { xs: '15px', sm: '20px', md: '25px' },
            paddingRight: { xs: '15px', sm: '20px', md: '25px', lg: '40px' },
          }}
        >
          { quote || "“The folks at Bendable Labs facilitate the best workshops around collective impact that I’ve ever participated in. If you’re ever invited to participate, jump at the opportunity. It’ll be the best thing you’ll ever do.”" }
        </Typography>
      </Stack>
       

      <Typography
        sx={{
          fontFamily: 'Sharp Sans',
          fontWeight: 'bold',
          color: '#ffffff',
          marginTop: { xs: '20px', sm: '30px', md: '40px' },
          marginLeft: { xs: '10px', sm: '20px', md: '30px' },
          fontSize: { xs: '20px', sm: '30px', md: '30px' },
          lineHeight: { xs: '18px', sm: '30px', md: '30px' },
          paddingLeft: { xs: '15px', sm: '20px', md: '25px' },
          paddingBottom: { xs: '10px', sm: '15px', md: '20px' },
        }}
      >
        &mdash;{ author || "Jennifer Dewees" }
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Sharp Sans',
          color: '#ffffff',
          // marginTop: { xs: '20px', sm: '20px', md: '20px' },
          marginLeft: { xs: '10px', sm: '20px', md: '30px' },
          fontSize: { xs: '16px', sm: '24px', md: '24px' },
          lineHeight: { xs: '18px', sm: '30px', md: '34px' },
          paddingLeft: { xs: '15px', sm: '20px', md: '25px' },
        }}
      >
        { title || "President of the Maryland Center for Construction Education and Innovation" }
      </Typography>

    </Box>
  );
};

export default QuoteBlock;
